import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/users")({
  staticData: { title: "Users" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/users/page.tsx"),
    "UsersPage",
  ),
})
